import React from "react";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Fade from 'react-reveal/Fade';
import Flash from 'react-reveal/Flash';

import './hero.scss';

import { ShowLanding } from 'component/reuse/show';


export default class HeroComponent extends React.Component {

  render (){
    return (
      <div id="hero" className=" my-5">
        <div className=" justify-content-between">

          <div className="mt-5 mb-4">
            <h1 className="family-h1 text-center jumbo-title"><span className="text-dark">Build amazing</span><span className="text-quaternary"> product walkthroughs</span></h1>
          </div>

          <div className="my-3 text-center">
            <p className="my-2 text-size-2 text-spacing-2"><span className="text-muted">Guided tours on your site in minutes!</span></p>
          </div>

          {/* <div className="my-5 text-center">
            <div className="row text-spacing-2 family-code small uppercase">
              <span className="col d-none d-lg-block"></span>
              <span className="col ">No video embeds</span>
              <span className="col ">Low bandwidth</span>
              <span className="col ">1 line javascript</span>
              <span className="col d-none d-lg-block"></span>
            </div>
          </div> */}

          <div className="my-5 animated slideInLeft">
            <Flash>
            <ShowLanding show_xid={'95i1shz4z'} text={"Play Demo!"} />
            </Flash>
            {/* <ShowLanding show_xid={"hiaaxob6y"} /> */}
          </div>

          <div className="flex-center">
            <Fade>
            <div className=" col-8 img img-fluid text-center animated slideInRight">
            <img className="hero lazyload" data-src="/static/images/hero.svg" alt="A new kind of presentation tool that helps you get your product offering across through on site presentations." />
            </div>
            </Fade> 
          </div>
          
        </div>
      </div>
    )
  }
}
